import React from 'react';
import CompanyPage from './company';

const OsintDashboard = () => <CompanyPage mode="dashboard" />;

export default OsintDashboard;
